export default __webpack_public_path__ + "static/media/Tablet-Checklist-SOP-1000.b87a9da8.png";